/**
 * 创建超时context
 * @param {function} need
 * @param {number} timeout
 * @returns {Promise<any>}
 */
function createTimeoutContext(need, timeout = 1000) {
    const def = need();
    return Promise.race([
        def,
        new Promise((_, reject) => {
            const id = setTimeout(() => {
                clearTimeout(id);
                reject(new Error(`Timeout after ${timeout / 1000} sec`));
            }, timeout);
        })
    ]);
}

/**
 * 创建可取消context
 */
function createCancelableContext(need) {
    const def = need();
    let out = {
        result: def,
        cancel: () => {
        }
    };
    Promise.race([
        def,
        new Promise((resolve) => {
            out.cancel = () => {
                resolve({});
            };
        })
    ]);

    return out;
}

export {
    createTimeoutContext,
    createCancelableContext,
};
